import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalStorageService } from '../../services/local-storage.service';
import moment from 'moment';

export interface ISignalRSettings {
  transportIndex: number;
  expireDate: Date;
}

/** Сервис для работы с SignalR */
@Injectable({
  providedIn: 'root',
})
export class SignalRLocalStorageService {
  private readonly _key = 'SignalR.PreferedTransport';
  private readonly _cacheDays = 1;

  private _serverDate: moment.Moment;
  private _serverDateBehaviorSubjectSubscription: Subscription = null;


  constructor(private _localStorage: LocalStorageService<ISignalRSettings>) {}

  public init(serverDateBehaviorSubject: BehaviorSubject<any>) {
    if (this._serverDateBehaviorSubjectSubscription) {
      this._serverDateBehaviorSubjectSubscription.unsubscribe();
    }

    this._serverDate = serverDateBehaviorSubject.value;

    this._serverDateBehaviorSubjectSubscription = serverDateBehaviorSubject.subscribe((serverDate) => {
      this._serverDate = serverDate;
    });
  }

  public getPreferedTransportIndex(defaultValue: number): number {
    let settings = this._localStorage.getItem(this._key);

    if (settings && this._serverDate.isBefore(moment(settings.expireDate))) {
      return settings.transportIndex;
    }

    return defaultValue;
  }

  public setPreferedTransportIndex(transportIndex: number) {
    let expireDate = this._serverDate
      .add(this._cacheDays, 'day')
      .toDate();

    const settings = {
      transportIndex: transportIndex,
      expireDate: expireDate
    } as ISignalRSettings;

    this._localStorage.setItem(this._key, settings);
  }
}
